export default (deviceName: string): boolean =>
  /mac|iphone|ipad|ipod/gi.test(deviceName)
